import script from "./tabList.vue?vue&type=script&setup=true&lang=ts"
export * from "./tabList.vue?vue&type=script&setup=true&lang=ts"

import "./tabList.vue?vue&type=style&index=0&id=37d2a31d&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_web_ta_paper_refs-heads-master/source_code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d2a31d"]])

export default __exports__